import { cookie } from '@ifeng-fe/ui_base';

export const getUserid = () => {
    return cookie.get('userid');
};

/**
 * 一维数组转换为二维数组
 * @param {Array} baseArray 原始数组
 * @param {Number} itemLen 各维度个数
 */
export const transformArr = (baseArray, itemLen) => {
    const res = [];
    const len = baseArray.length;
    const lineNum = len % itemLen === 0 ? len / itemLen : Math.floor(len / itemLen + 1);

    for (let i = 0; i < lineNum; i++) {
        const temp = baseArray.slice(i * itemLen, i * itemLen + itemLen);

        res.push(temp);
    }

    return res;
};

export const getUserkey = () => {
    return cookie.get('userkey');
};

export const getOs = () => {
    const UA = navigator.userAgent.toLocaleLowerCase();

    if (UA.includes('mobile')) {
        if (UA.includes('android')) {
            return 'android';
        }

        return 'ios';
    }

    return 'pc';
};

export const getParam = (key, search) => {
    const params = search.replace('?', '').split('&');
    let ret = '';

    if (params) {
        for (let i = 0, len = params.length; i < len; i++) {
            const pair = params[i].split('=');

            if (key === pair[0]) {
                ret = pair[1];
            }
        }
    }

    return ret;
};
